import type { SVGProps } from "react";
export default function SvgBenchmarkAppNoShadow(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 112 112"
			{...props}
		>
			<foreignObject width={111.626} height={111.626} x={-4.36816} y={4.37402}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1110_681_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_i_1110_681)">
				<path
					fill="url(#paint0_linear_1110_681)"
					fillOpacity={0.6}
					d="M89.258 60.187c0-20.884-16.93-37.813-37.813-37.813s-37.813 16.93-37.813 37.813S30.562 98 51.445 98s37.813-16.93 37.813-37.813"
				/>
				<path
					stroke="url(#paint1_linear_1110_681)"
					d="M51.445 22.874c20.607 0 37.313 16.706 37.313 37.313S72.053 97.5 51.445 97.5c-20.607 0-37.313-16.706-37.313-37.313s16.706-37.313 37.313-37.313Z"
				/>
			</g>
			<foreignObject width={81.9336} height={81.9336} x={34.4346} y={-4}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1110_681_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_i_1110_681)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M52.435 56.755V17.182c0-1.88 1.618-3.315 3.492-3.172A46.1 46.1 0 0 1 85 27.367a46.1 46.1 0 0 1 13.357 29.074c.143 1.874-1.296 3.492-3.172 3.492H55.613a3.176 3.176 0 0 1-3.176-3.175z"
				/>
				<path
					stroke="url(#paint2_linear_1110_681)"
					strokeOpacity={0.5}
					d="m52.938 56.55-.003-.002V17.183c0-1.575 1.357-2.796 2.954-2.674A45.6 45.6 0 0 1 84.647 27.72 45.6 45.6 0 0 1 97.86 56.48c.122 1.596-1.101 2.954-2.673 2.954H55.612a2.676 2.676 0 0 1-2.675-2.676z"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="M52.26 59.117V48.074c0-.525.452-.926.975-.886a12.86 12.86 0 0 1 8.113 3.728 12.86 12.86 0 0 1 3.728 8.114.896.896 0 0 1-.885.974H53.147a.89.89 0 0 1-.887-.887"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1110_681"
					x1={51.6378}
					x2={51.6378}
					y1={22.374}
					y2={97.9996}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1110_681"
					x1={51.4449}
					x2={23.5218}
					y1={23.2022}
					y2={85.2562}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1110_681"
					x1={75.4014}
					x2={75.4014}
					y1={14}
					y2={59.9333}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1110_681_clip_path" transform="translate(4.368 -4.374)">
					<path d="M89.258 60.187c0-20.884-16.93-37.813-37.813-37.813s-37.813 16.93-37.813 37.813S30.562 98 51.445 98s37.813-16.93 37.813-37.813" />
				</clipPath>
				<clipPath id="bgblur_1_1110_681_clip_path" transform="translate(-34.435 4)">
					<path d="M52.435 56.755V17.182c0-1.88 1.618-3.315 3.492-3.172A46.1 46.1 0 0 1 85 27.367a46.1 46.1 0 0 1 13.357 29.074c.143 1.874-1.296 3.492-3.172 3.492H55.613a3.176 3.176 0 0 1-3.176-3.175z" />
				</clipPath>
				<filter
					id="filter0_i_1110_681"
					width={111.626}
					height={111.626}
					x={-4.36816}
					y={4.37402}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_681" />
				</filter>
				<filter
					id="filter1_i_1110_681"
					width={81.9336}
					height={81.9336}
					x={34.4346}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_681" />
				</filter>
			</defs>
		</svg>
	);
}
